<template>
  <b-card class="person-files-card shadow">
    <file-preview-dialog :visible="filePreview.show" :s3-key="filePreview.s3Key" @close="onFilePreviewClose" />

    <b-table
      hover
      show-empty
      :items="items"
      :fields="fields"
      :busy="loading"
      :empty-text="$t('No files associated with this person')"
      class="person-files-table mb-0"
      @row-clicked="onRowClick"
    >
      <template #table-colgroup>
        <col :style="{ width: '80%' }" />
        <col :style="{ width: '20%' }" />
      </template>

      <template #cell(fileName)="{ item, index }">
        <b-button
          v-if="isImage(item.s3Key)"
          pill
          variant="light"
          :disabled="!item.s3Key"
          class="btn-sm preview-file-button mr-4"
          @click="onRowClick(item, index)"
        >
          <b-icon icon="paperclip" rotate="90" class="preview-icon" />
        </b-button>

        <s3-file-download-button v-else :ref="`download-${index}`" :s3Key="item.s3Key" class="mr-4" />

        <span>{{ $t(`fileName.${item.fileName.split('.')[0]}`) }}</span>
      </template>

      <template #cell(loadDate)="{ item }">
        <span>{{ item.loadDate }}</span>
      </template>

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle" />
          <strong>Loading...</strong>
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import constants from '@/constants';

import FilePreviewDialog from '@/components/organisation/FilePreviewDialog';
import S3FileDownloadButton from '@/components/common/S3FileDownloadButton';

import getRef from '@/utils/getRef';
import isImage from '@/utils/isImage';

export default {
  name: 'PersonFiles',

  components: { FilePreviewDialog, S3FileDownloadButton },

  props: {
    files: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      fileStatuses: constants.companyFiles.statuses,
      filePreview: {
        show: false,
        s3Key: null,
      },
      fields: [
        { key: 'fileName', label: this.$t('Documents & Certificates') },
        { key: 'loadDate', label: this.$t('Upload date') },
      ],
    };
  },

  computed: {
    items() {
      if (!this.files) {
        return [];
      }

      return this.files.filter((item) => {
        return !!item.status && item.status !== this.fileStatuses.NOT_LOADED && !!item.s3Key;
      });
    },
  },

  methods: {
    isImage,

    getColumnStatusData(item) {
      return this.$t(constants.companyFiles.statuses[item.status] ? `fileStatus.${item.status}` : 'Unknown status');
    },

    onRowClick(item, index) {
      if (isImage(item.s3Key)) {
        this.filePreview = { show: true, s3Key: item.s3Key };
      } else {
        const ref = getRef(this.$refs, `download-${index}`);
        if (ref) {
          ref.onButtonClick();
        }
      }
    },

    onFilePreviewClose() {
      this.filePreview = { show: false, s3Key: null };
    },
  },
};
</script>

<style scoped>
.person-files-card >>> .card-body {
  padding: 32px 32px 48px;
}

.person-files-card >>> .card-body > h4 {
  padding: 0 15px;
}

.person-files-table >>> thead {
  border-top: none !important;
}

.person-files-table >>> thead th {
  font-weight: 500;
  font-size: 0.875rem;
}

.person-files-table >>> thead th:first-child {
  font-weight: 700;
  font-size: 1.5rem;
}

.person-files-table >>> tbody {
  border-top-width: 1px !important;
}

.person-files-table >>> tbody > tr {
  cursor: pointer;
}

.person-files-table >>> tbody > tr > td {
  vertical-align: middle;
}

.preview-file-button {
  background-color: #e2e4e5;
  box-shadow: 0px 3px 6px 0px #97979752;
  border-color: #e2e4e5;
  padding: 0 0.875em;
}
</style>



// WEBPACK FOOTER //
// src/components/organisation/PersonFiles.vue